export class TranpsVolumeFormModel {
    constructor(
        public qVol: number = 0,
        public esp: string = '',
        public marca: string = '',
        public nVol: string = '',
        public pesoL: number = 0,
        public pesoB: number = 0,
    ) { }
}